"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const icon_1 = __importDefault(require("./icon"));
const styled_div_1 = __importDefault(require("./styled-div"));
const theme_1 = __importDefault(require("../styles/theme"));
const typography_1 = require("../styles/typography");
/**
 *
 * Breadcrumbs Usage Example:
 *
 *  const steps = [
 *    {
 *      title: 'Accounts',
 *      linkTo: '/accounts',
 *    },
 *    {
 *      title: 'Merge',
 *      linkTo: '/accounts/merge',
 *    },
 *  ];
 *
 *  <Breadcrumbs steps={steps} />
 *
 *
 * WARNING: Before changing this file, please strongly consider whether your change is
 * necessary (we want to avoid unexpected bugs in other views).
 * This code is meant to be shared by many views throughout our app and should not
 * contain logic specifc to how your view is using it.
 *
 */
const BreadcrumbContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding-top: ${(props) => props.theme.spacing.xs};
  padding-bottom: ${(props) => props.theme.spacing.xs};
  height: ${(props) => props.theme.pageLayout.menuHeight};
  background: transparent;
  padding-left: ${(props) => props.theme.spacing.s};

  a {
    ${typography_1.smallText}

    text-decoration: none;
    color: ${(props) => props.theme.colors.textNavigation};
    margin-right: ${(props) => props.theme.spacing.s};

    &:last-child {
      background: ${(props) => props.theme.colors.backgroundPrimaryAccent};
      color: ${(props) => props.theme.colors.primaryAccent};
      border-radius: 100px;
      padding: ${(props) => `${props.theme.spacing.xs} ${props.theme.spacing.s}`};
    }
  }
`;
/**
 * Provides a navigational component that can display the path to the user's current location.
 * Must be used within a `Router` component.
 */
const Breadcrumbs = (_a) => {
    var { renderLink = (linkTo, title) => (react_1.default.createElement(react_router_dom_1.Link, { replace: true, to: linkTo }, title)), steps } = _a, commonProps = __rest(_a, ["renderLink", "steps"]);
    return (react_1.default.createElement(BreadcrumbContainer, Object.assign({}, commonProps), steps.map((step, i) => {
        const StepLink = renderLink(step.linkTo, step.title);
        return (react_1.default.createElement(react_1.Fragment, { key: `${step.linkTo}-${step.title}` },
            StepLink,
            i < steps.length - 1 && (react_1.default.createElement(styled_div_1.default, { marginRight: "s" },
                react_1.default.createElement(icon_1.default, { name: "chevron_right", color: theme_1.default.colors.textDark, size: "12px" })))));
    })));
};
exports.Breadcrumbs = Breadcrumbs;
exports.default = exports.Breadcrumbs;
